module.exports = __webpack_public_path__ + "static/media/logoblack.b5187d0a.png";